export default __webpack_public_path__ + "static/image-5c4096acc3597276d48944e9d9cd0f43.png";